import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahFreeTrunkEditor = () => {
  const [form, setForm] = useState({
    titleEn: "",
    titleAr: "",
    titleKu: "",
    descEn: "",
    descAr: "",
    descKu: "",
    videoUrl: ""
  });

  const [videoPreview, setVideoPreview] = useState(null);
  const [loading, setLoading] = useState(true);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  // =========================================
  // LOAD 3-LANGUAGE DATA + VIDEO
  // =========================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VFTrunkSection?lang=en`),
          axios.get(`${API_BASE}/api/VFTrunkSection?lang=ar`),
          axios.get(`${API_BASE}/api/VFTrunkSection?lang=ku`)
        ]);

        setForm({
          titleEn: en.data.title,
          descEn: en.data.description,

          titleAr: ar.data.title,
          descAr: ar.data.description,

          titleKu: ku.data.title,
          descKu: ku.data.description,

          videoUrl: en.data.video
        });

        setVideoPreview(en.data.video);

        setLoading(false);
      } catch (err) {
        console.error("Failed to load VFTrunkSection:", err);
        setLoading(false);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // =========================================
  // SAVE TEXT UPDATE
  // =========================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VFTrunkSection/1`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Trunk section updated.");
    } catch (err) {
      console.error(err);
      alert("Failed to update.");
    }
  };

  // =========================================
  // UPLOAD VIDEO
  // =========================================
  const handleUpload = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();
    fd.append("Video", uploadFile);

    try {
      await axios.post(`${API_BASE}/api/VFTrunkSection/1/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      alert("Video updated!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Video upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">

      <h2 className="fw-bold mb-4">Voyah FREE – Trunk Section Editor</h2>

      {/* =======================================
            TEXT EDITORS (3 LANG)
      ======================================== */}
      <div className="row">
        {LANGS.map((l) => (
          <div className="col-lg-4 col-md-6 mb-4" key={l}>
            <div className="card shadow-sm border-0">
              <div className="card-body">
                <h5 className="text-primary mb-3">{l} Version</h5>

                <label className="form-label">Title</label>
                <input
                  className="form-control mb-2"
                  name={`title${l}`}
                  value={form[`title${l}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Description</label>
                <textarea
                  rows={4}
                  className="form-control"
                  name={`desc${l}`}
                  value={form[`desc${l}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* =======================================
            VIDEO PREVIEW
      ======================================== */}
      <h4 className="fw-bold mb-3">Video Preview</h4>

      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">

          {videoPreview ? (
            <video
              src={resolveUrl(videoPreview)}
              controls
              className="w-100 rounded mb-3"
              style={{ maxHeight: "320px", objectFit: "cover" }}
            />
          ) : (
            <p>No video uploaded.</p>
          )}

          <button
            className="btn btn-primary"
            onClick={() => {
              setUploadFile(null);
              setShowModal(true);
            }}
          >
            Upload / Replace Video
          </button>
        </div>
      </div>

      {/* =======================================
            MODAL
      ======================================== */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload New Video</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="video/mp4,video/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={handleUpload}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
};

export default VoyahFreeTrunkEditor;
